import React from 'react';
import { Box, Typography } from '@mui/material';

function Content() {
  return (
    <Box sx={{ marginTop: '24px' }}> {/* Abstand vom Header zum Content erhöhen */}
      <Typography variant="h4">Dashboard Content</Typography>
      <Typography paragraph>
        Hier kannst du den Inhalt des Dashboards hinzufügen, einschließlich Tabellen, Diagramme usw.
      </Typography>
    </Box>
  );
}

export default Content;
